import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import RouteTransition from "@/components/RouteTransition";
import SmoothScroll from "@/components/SmoothScroll";
import NoIndexFallback from "@/components/NoIndexFallback";
import Home from "@/pages/Home";
import Logistics from "@/pages/Logistics";
import Properties from "@/pages/Properties";
import Government from "@/pages/Government";
import Partnerships from "@/pages/Partnerships";
import Diversity from "@/pages/Diversity";
import FoundersLetter from "@/pages/FoundersLetter";
import Contact from "@/pages/Contact";

function App() {
  return (
    <div className="min-h-screen bg-black text-white" data-testid="app-root">
      <BrowserRouter>
        <SmoothScroll>
          <RouteTransition />
          <Navigation />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/logistics" element={<Logistics />} />
              <Route path="/properties" element={<Properties />} />
              <Route path="/government" element={<Government />} />
              <Route path="/partnerships" element={<Partnerships />} />
              <Route path="/diversity" element={<Diversity />} />
              <Route path="/letter" element={<FoundersLetter />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="*" element={<NoIndexFallback />} />
            </Routes>
          </main>
          <Footer />
        </SmoothScroll>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
